__turbopack_context__.v({
  "bannerWrapper": "styles-module__7KzKJG__bannerWrapper",
});
